// -- == //
import NewsForm from '../lib/newsForm';
import AppLoading from 'components/appLoading';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function NewsCreatePage() {
  const { newsCreate, newsUpload } = useTypedSelector((state: any) => state.News);

  return (
    <S.Container>
      <PageTitle title="Create News" />
      <NewsForm data={{} as any} loading={newsCreate.loading} />

      <AppLoading loading={newsCreate.loading || newsUpload.loading} />
    </S.Container>
  );
}
